import Header from './components/Header';
import './styles/index.scss';
import background from './assets/background.png';
import Menus from './components/Menus';
import Avis from './components/Avis';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Box } from '@mui/material';
import React from 'react';
function App() {
  const homeRef = React.createRef();
  const menuRef = React.createRef();
  const avisRef = React.createRef();
  const contactRef = React.createRef();
  return (
    <Box sx={{ paddingBottom: '56px' }}>
      <Header homeRef={homeRef} menuRef={menuRef} avisRef={avisRef} contactRef={contactRef} />
      <Box
        ref={homeRef}
        sx={{
          width: '100%',
          height: { xs: '50vh', md: '100vh' },  // Adjust the height based on screen size
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',  // This will make sure the image covers the entire div
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div ref={menuRef}><Menus /></div>
      <div ref={avisRef}><Avis /></div>
      <div ref={contactRef}><Contact /></div>
      <footer>
        <Footer />
      </footer>
    </Box>
  );
}

export default App;
